import { FiSmartphone, FiCheckCircle, FiDollarSign, FiBell } from 'react-icons/fi';

const StatCard = ({ title, value, Icon, color }) => {
  return (
    <div className="bg-white dark:bg-gray-800 p-5 rounded-2xl border border-gray-100 dark:border-gray-700 flex items-center justify-between hover:shadow-sm dark:hover:shadow-none transition-all">
      <div className="flex flex-col">
        <h3 className="text-[13px] text-gray-500 dark:text-gray-400 font-medium mb-1 truncate max-w-[120px]" title={title}>
          {title}
        </h3>
        <p className="text-2xl font-extrabold text-gray-900 dark:text-white truncate max-w-[140px]" title={value}>
          {value}
        </p>
      </div>
      <div className={`p-2.5 rounded-full ${color.icon} flex-shrink-0`}>
        <Icon className="w-5 h-5" />
      </div>
    </div>
  );
};

const StatsCards = ({ userApps, totalInvested, formatPrice }) => {

  const statsData = [
    {
      title: 'Apps Ativos',
      value: userApps.length,
      Icon: FiSmartphone,
      color: {
        icon: 'bg-violet-50 dark:bg-violet-900/30 text-violet-500 dark:text-violet-400',
      }
    },
    {
      title: 'Total Investido',
      value: formatPrice(totalInvested),
      Icon: FiDollarSign,
      color: {
        icon: 'bg-green-50 dark:bg-green-900/30 text-green-500 dark:text-green-400',
      }
    },
    {
      title: 'Notificações Hoje',
      value: '0',
      Icon: FiBell,
      color: {
        icon: 'bg-blue-50 dark:bg-blue-900/30 text-blue-500 dark:text-blue-400',
      }
    },
    {
      title: 'Inscritos Ativos',
      value: '0',
      Icon: FiCheckCircle,
      color: {
        icon: 'bg-amber-50 dark:bg-amber-900/30 text-amber-500 dark:text-amber-400',
      }
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6 mb-8">
      {statsData.map((stat, index) => (
        <StatCard key={index} {...stat} />
      ))}
    </div>
  );
};

export default StatsCards;
